import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { Mail, Upload } from 'lucide-react';
import theme from './theme';
import { auroraStops } from './brand/tokens';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Aurora from './components/Aurora';
import WaitlistPage from './pages/WaitlistPage';

// The landing page ships in the main bundle; everything else loads on demand.
const UploadPage = lazy(() => import('./pages/UploadPage'));
const BrandPage = lazy(() => import('./pages/BrandPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

const navItems = [
  { name: 'Waitlist', url: '/', icon: Mail },
  { name: 'Upload', url: '/upload', icon: Upload },
];

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" onExitComplete={() => window.scrollTo(0, 0)}>
      <Suspense fallback={<Box sx={{ flex: 1 }} />} key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<WaitlistPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/brand" element={<BrandPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MotionConfig reducedMotion="user">
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Box sx={{ position: 'relative', minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
            <Aurora colorStops={auroraStops} blend={0.5} amplitude={1.6} speed={0.6} />
            <NavBar items={navItems} />
            <AnimatedRoutes />
            <Footer />
          </Box>
        </Router>
      </MotionConfig>
    </ThemeProvider>
  );
}

export default App;
